<template>

  <form id="maintanceReasonForm" class="mx-auto col-sm-8" @submit.prevent>

    <div class="form-group" :class="{ 'has-error': errors.has('maintance_reason') }">
      <label for="maintance_reason">{{ $t('maintance_reason') }}</label>
        <input
          type="text"
          id="maintance_reason"
          name="maintance_reason"
          class="form-control"
          :placeholder="$t('ph_maintance_reason')"
          v-model="maintanceReason.name"
          v-validate="'required'"
        >
      <small v-show="errors.has('maintance_reason')" class="form-text">
        {{ errors.first('maintance_reason') }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t('active') }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="maintanceReason.isActive">
        <label class="onoffswitch2-label" for="isActive">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t('save') }}
        </LoaderButton>
      </div>
    </div>

  </form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: 'MaintanceReasonForm',
  components: {
    LoaderButton
  },
  props: {
    maintanceReason: {
      type: Object,
      default: () => ({
        name: '',
        isActive: true
      })
    }
  },
  computed: {
    ...mapState({
      maintancereasons: state => state.maintancereason.all
    })
  },
  methods: {
    ...mapActions('maintancereason', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }
      const { id } = this.maintanceReason
      let promise
      if (id) {
        promise = this.edit({ id, data: this.maintanceReason })
      } else {
        promise = this.create(this.maintanceReason)
      }
      const result = await promise
      if (result) {
        this.$router.push({ name: 'listmaintancereasons' })
      }
    }
  },
  destroyed () {
    this.cleanState()
  }
}
</script>
